import { FC } from 'react';
import { useLottie } from 'lottie-react';
import animData from './logo-loader-data.json';

interface BPLogoLoaderProps {
  className?: string;
}

const BPLogoLoader: FC<BPLogoLoaderProps> = ({ className }) => {
  const options = {
    animationData: animData,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options, {});

  return <div className={className}>{View}</div>;
};

export default BPLogoLoader;
